import axios from 'axios'
import store from '@/store'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import router from '@/router'

function httpFail(error) {
    // Reject on Laravel-driven validation errors
    if (error.response && error.response.status === 422) {
        return Promise.reject(error)
    }

    // Refresh tokens and reject to be further handled be the request initiator
    if (error.response && error.response.status === 419) {
        return Promise.reject(error);
    }

    // If internal error
    if (error.message && !error.response) {
        // Due to a possible bug in Laravel Echo, whitelist Echo server error
        // See explanation above
        if (error.message === "Cannot read property 'socketId' of undefined") {
            // showHttpError(error.message);
            return Promise.resolve(error)
        }

        // Display any other errors to the user and reject
        showHttpError(error.message)
        return Promise.reject(error)
    }

    // Redirect to log in page if unauthenticated
    if (error.response && error.response.status === 401) {
        if (error.response.data.message == 'Two factor authentication required.') {
            store.commit('auth/toggleOTPModal');
            return;
        }

        store.commit('auth/setUser', null);        

        if (error.response.config.url !== 'user') {
            store.commit('auth/sessionExpired', true);
            router.push({name: 'login'});
        }

        return Promise.reject(error);
    }

    // Redirect if the backend asks it
    if (error.response && error.response.status === 402 && error.response.data.redirect) {
        window.router.push(error.response.data.redirect)
        return Promise.reject(error)
    }

    // Show all other errors
    showHttpError(error)
    return Promise.reject(error)
}

function showHttpError({ response }) {
    Swal.fire({
        type: 'error',
        title: 'Oops...',
        html: response.data.message
    })
}

function refreshAppTokens() {
    // Retrieve a new page with a fresh token
    //axios.get('sanctum/csrf-cookie');
}

class Http {
    constructor() {
        let token = window.localStorage.getItem('token') || window.sessionStorage.getItem('token');
        this.axios = axios.create({
            baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL : '/',
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + token
            }
        })

        //this.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        //this.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content
        this.axios.defaults.withCredentials = true;
        this.axios.interceptors.response.use(response => response, error => httpFail(error))
    }

    setAuthToken(token) {
        this.axios.defaults.headers['Authorization'] = 'Bearer ' + token
    }

    async get(url, config) {
        return await this.axios.get(url, config)
    }

    async post(url, data, config) {
        return await this.axios.post(url, data, config).catch(error  => {
            if (error.response && error.response.status === 419) {  
                return this.get('sanctum/csrf-cookie')
                           .then(() => {
                               return this.post(url, data, config)
                           });
            }

            return Promise.reject(error)
        })
    }

    async patch(url, data, config) {
        return await this.axios.patch(url, data, config).catch(error => {
            if (error.response && error.response.status === 419) {
                return this.get('sanctum/csrf-cookie')
                    .then(() => {
                        return this.patch(url, data, config)
                    });
            }

            return Promise.reject(error)
        })
    }

    async delete(url, config) {
        return await this.axios.delete(url, config).catch(error => {
            if (error.response && error.response.status === 419) {
                return this.get('sanctum/csrf-cookie')
                    .then(() => {
                        return this.delete(url, config)
                    });
            }

            return Promise.reject(error)
        })
    }
}

export default new Http()
